import React, { useState } from "react";
import PersonDetailsSection from "./sections/PersonDetailsSection";
import AddressSection from "./sections/AddressSection";
import DateOfBirthSection from "./sections/DateOfBirthSection";
import EmailSection from "./sections/EmailSection";
import GenderSection from "./sections/GenderSection";
import NationalitySection from "./sections/NationalitySection";
import DisplayNameSection from "./sections/DisplayNameSection";

const PersonalDetails = () => {
  const [firstName, setFirstName] = useState("Rishabh");
  const [lastName, setLastName] = useState("Sagar");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [postcode, setPostcode] = useState("");
  const [country, setCountry] = useState("");
  const [day, setDay] = useState("25");
  const [month, setMonth] = useState("09");
  const [year, setYear] = useState("2000");
  const [gender, setGender] = useState("Male");
  const [nationality, setNationality] = useState("India");
  const [displayName, setDisplayName] = useState("Rishabh Sagar");
  const [newDisplayName, setNewDisplayName] = useState("");
  const [email, setEmail] = useState("rishabhsagarajmer@gmail.com");
  const [newEmail, setNewEmail] = useState("");

  return (
    <div flex>
      {/* <Sidebar22/> */}
      <PersonDetailsSection
        firstName={firstName}
        setFirstName={setFirstName}
        lastName={lastName}
        setLastName={setLastName}
      />
      <NationalitySection
        nationality={nationality}
        setNationality={setNationality}
      />
      <GenderSection gender={gender} setGender={setGender} />
      <EmailSection
        email={email}
        setEmail={setEmail}
        newEmail={newEmail}
        setNewEmail={setNewEmail}
      />
      <DisplayNameSection
        displayName={displayName}
        setDisplayName={setDisplayName}
        newDisplayName={newDisplayName}
        setNewDisplayName={setNewDisplayName}
      />
      <DateOfBirthSection
        day={day}
        month={month}
        setDay={setDay}
        setMonth={setMonth}
        year={year}
        setYear={setYear}
      />
      <AddressSection
        city={city}
        setCity={setCity}
        postcode={postcode}
        setPostcode={setPostcode}
        country={country}
        setCountry={setCountry}
        address={address}
        setAddress={setAddress}
      />
    </div>
  );
};

export default PersonalDetails;
